module.exports = __webpack_public_path__ + "static/img/csf.fbdb1f2d.svg";